import { fetchIdentification } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type { IdentificationT } from '@lotushealth/lotushealth_js_sdk/schemas';
import { APILevelT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

/**
 * Fetch identification for the authenticated user, including their backend user ID.
 */
export async function fetchMyIdentification(signal?: AbortSignal): Promise<IdentificationT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchIdentification(APILevelT.app, config);
  return lotusHealthZod.fetchIdentificationResponse.parse(response.data).identification;
}
